import getCookie from "./getCookie"

const getTrackingId = () => {
  let tracking_id = getCookie("tracking_id_trk")
  if (!tracking_id) {
    tracking_id = crypto.randomUUID()
    document.cookie = `tracking_id_trk=${tracking_id};path=/;domain=${window.location.hostname}`
  }
  return tracking_id
}

export default getTrackingId
